module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "body"
  }, [_c('span', [_vm._v("This was the first aha moment for me when it came to understanding different organizing styles and how to use those styles to develop systems that actually worked. I realized little kids just don’t clean the same way I did, and therefore they would need a specific system that works for the way they think and clean up.")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("As I started working to organize the homes of clients and friends and family, I began to notice and keep track of the unique ways each of them organized and cleaned their homes. "), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("There seemed to be four really distinct organizing styles, and I could soon fit everyone I knew into one of these four categories, which I called “ClutterBugs”.")]), _vm._v(" "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Of course there is a bit of overlap, but for the most part, each person really does have a tendency to need their items organized a certain way, and once that way is identified, it is easier to create a system that will work long term for that person and their family. "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', [_vm._v("Now that I understand my husband’s organizing style, I can appreciate why he has countless stacks of neatly piled papers always on his desk (I can appreciate it, not like it), and I can help him create efficient ways to deal with paper. When I visit my sister’s home, I understand her need to “see” everything she has and her fear that if she puts important things away, she will forget about them and they will be lost forever. I am also now completely aware of my own tendency to “hide and shove” things into hidden areas in my home, and I can create systems that allow me to continue to hide and shove, but in a more organized way. ")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Discovering your own unique style is like a light bulb moment! You will be able to see what systems can work best for you and why certain systems will never work for you. Armed with this new knowledge, you will be able to create real-life systems and solutions and an organizing game plan that will transform your home and your life forever."), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body1"
  }, [_c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "subchap"
  }, [_vm._v("So, what’s your  organizing style?  Take the following  test to find out!"), _c('span', {
    staticClass: "normal-caps2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body2"
  }, [_c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("Note: When taking this test, try to think about your own personal spaces inside your home and how you personally deal with your belongings. When living with different people, the state of our current home can be a reflection of all of those styles combined. Try to answer this test objectively and from your own personal point of view. ")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "test-question"
  }, [_vm._v("You enjoy reading a:"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "calibre4"
  }, [_c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("1.\t")]), _vm._v("Magazine or Comic Book"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("2.\t")]), _vm._v("Non-Fiction Book"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("3.\t")]), _vm._v("Fiction Book"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("4.\t")]), _vm._v("Newspaper"), _c('span', {
    staticClass: "normal-caps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "test-question"
  }, [_vm._v("You find your biggest clutter issue is:"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "calibre4"
  }, [_c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("1.\t")]), _vm._v("I have “stuff” everywhere "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("2.\t")]), _vm._v("Paper and other personal or "), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("important items"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("3.\t")]), _vm._v("Inside closets, cabinets, and "), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("spare rooms "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("4.\t")]), _vm._v("I hold on to too many things that "), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("may be useful in the future"), _c('span', {
    staticClass: "normal-caps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "test-question"
  }, [_vm._v("Your home usually looks:"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "calibre4"
  }, [_c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("1.\t")]), _vm._v("Cluttered with random things everywhere"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("2.\t")]), _vm._v("Tidy with occasional piles of papers or things I haven’t got to yet"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("3.\t")]), _c('span', [_vm._v("Very clean and tidy, but behind closed doors, closets and drawers can be a mess")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("4.\t")]), _vm._v("A bit cluttered with projects or items I am still using in some areas"), _c('span', {
    staticClass: "normal-caps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "test-question"
  }, [_vm._v("In my spare time I enjoy: "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "calibre4"
  }, [_c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("1.\t")]), _vm._v("Visiting with friends or family outside of my home"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("2.\t")]), _c('span', [_vm._v("Learning, reading, or trying something new ")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("3.\t")]), _vm._v("Relaxing in my home "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("4.\t")]), _vm._v("Enjoying my favorite hobbies"), _c('span', {
    staticClass: "normal-caps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "test-question"
  }, [_vm._v("The areas in your home that need the most organizing are:"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "calibre4"
  }, [_c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("1.\t")]), _vm._v("Bedrooms, kitchen, and just about everywhere else"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("2.\t")]), _vm._v("Desk, filing systems, and office"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("3.\t")]), _vm._v("Closets, drawers, storage rooms and spare bedrooms"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("4.\t")]), _vm._v("Work areas like kitchen, craft rooms, and garage"), _c('span', {
    staticClass: "normal-caps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "test-question"
  }, [_vm._v("When it comes to cleaning my home I generally:"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "calibre4"
  }, [_c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("1.\t")]), _vm._v("Always have to spend a lot of time tidying up before I can clean it"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("2.\t")]), _vm._v("Keep my home clean and tidy, but it isn’t a priority in my life"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("3.\t")]), _vm._v("Have a pretty clean house and I enjoy cleaning it"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("4.\t")]), _vm._v("Clean it sometimes, but some areas are always pretty cluttered"), _c('span', {
    staticClass: "normal-caps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "test-question"
  }, [_vm._v("My biggest organizing challenge is:"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "calibre4"
  }, [_c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("1.\t")]), _vm._v("Out of sight is out of mind, so I tend to leave everything out all the time"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("2.\t")]), _vm._v("I just haven’t scheduled time to organize some areas efficiently"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("3.\t")]), _vm._v("I tend to neglect hidden areas in my home, like storage rooms"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("4.\t")]), _vm._v("I hate putting things away that I am just going to take out again later"), _c('span', {
    staticClass: "normal-caps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "test-question"
  }, [_vm._v("If a friend called and said she would be coming over in ten minutes, you would:"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "calibre4"
  }, [_c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("1.\t")]), _vm._v("Make a mad-dash grabbing as much clutter as you could and storing it out of sight"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("2.\t")]), _vm._v("Not do much differently"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("3.\t")]), _vm._v("Wipe counters and scrub the bathrooms in a hurry"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("4.\t")]), _vm._v("Finish up whatever it was you were working on"), _c('span', {
    staticClass: "normal-caps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "test-question"
  }, [_vm._v("When I am anxious, I:"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "calibre4"
  }, [_c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("1.\t")]), _vm._v("Talk it over in my head or speak with close friends and family"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("2.\t")]), _vm._v("Try to analyze and mentally prepare for all scenarios"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("3.\t")]), _vm._v("Worry and get myself worked up"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("4.\t")]), _vm._v("Distract myself with hobbies or work"), _c('span', {
    staticClass: "normal-caps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "test-question"
  }, [_vm._v("I remember things best from:"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "calibre4"
  }, [_c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("1.\t")]), _vm._v("Visual pictures and instructions"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("2.\t")]), _vm._v("Reading and researching about it "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("3.\t")]), _vm._v("Someone showing me how to do it"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("4.\t")]), _vm._v("Figuring it out on my own"), _c('span', {
    staticClass: "normal-caps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "test-question"
  }, [_vm._v("My excuse for not organizing my home is:"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "calibre4"
  }, [_c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("1.\t")]), _vm._v("There is so much clutter that I am overwhelmed and don’t know where  to start"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("2.\t")]), _c('span', [_vm._v("I am a bit of a perfectionist, so organizing takes a long time to do it right")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("3.\t")]), _vm._v("No one except for our family can see all of my hidden messy areas, so why bother"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("4.\t")]), _vm._v("I’m always busy with projects and hobbies and I do not have the time"), _c('span', {
    staticClass: "normal-caps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "test-question"
  }, [_vm._v("I like my favorite things to be:"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "calibre4"
  }, [_c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("1.\t")]), _vm._v("Out where I can always see them or else they may get lost"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("2.\t")]), _vm._v("Stored or displayed properly so that they will last"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("3.\t")]), _vm._v("Neat and tidy and displayed in an eye-pleasing way"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("4.\t")]), _vm._v("Where I can easily use them often"), _c('span', {
    staticClass: "normal-caps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "test-question"
  }, [_vm._v("I like to decorate my home:"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "calibre4"
  }, [_c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("1.\t")]), _vm._v("With bold colors and artwork"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("2.\t")]), _vm._v("With minimal, neutral colors"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("3.\t")]), _vm._v("\tWith current design trends"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("4.\t")]), _vm._v("\tWith useful, functional pieces"), _c('span', {
    staticClass: "normal-caps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "test-question"
  }, [_vm._v("I would like my home to be:"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('ol', {
    staticClass: "calibre4"
  }, [_c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("1.\t")]), _vm._v("Fun and Bright"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("2.\t")]), _vm._v("Functional and Minimal"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("3.\t")]), _vm._v("\tBeautiful and Cozy"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "test-answer"
  }, [_c('span', {
    staticClass: "char-style-override5"
  }, [_vm._v("4.\t")]), _vm._v("\tPractical and Efficient"), _c('span', {
    staticClass: "normal-caps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "normal-caps4"
  }), _c('span', {
    staticClass: "normal-caps4"
  })]), _vm._v(" "), _c('p', {
    staticClass: "subchap"
  }, [_vm._v("What is your Organizing Style?"), _c('span', {
    staticClass: "normal-caps2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Add up your answers. Are you mostly a 1, 2, 3 or 4? You may also be a combination of all of these organizing styles! Below are descriptions of each style and some tips and tricks that can help you finally get and stay organized! "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "b-head"
  }, [_vm._v("What Clutterbug Are You?"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body3"
  }, [_vm._v("If you answered mostly "), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("1")]), _vm._v(", "), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("you are a "), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("BUTTERFLY!")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body3"
  }, [_vm._v("If you answered mostly "), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("2")]), _vm._v(", "), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("you are a "), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("CRICKET!")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body3"
  }, [_vm._v("If you answered mostly "), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("3")]), _vm._v(", "), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("you are a "), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("LADYBUG!")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body3"
  }, [_vm._v("If you answered mostly "), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("4")]), _vm._v(", "), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("you are a "), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("BEE!")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("Note: There is, in fact, a fifth “ClutterBug,” ")]), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("the rare and amazing “Dragonfly.” A Dragonfly is an incredibly organized person who is usually an extreme minimalist and rarely, if ever, struggles with clutter or mess. We hate Dragonflies. If you are a Dragonfly, you can stop reading this book now—I will have nothing more to offer you!")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-aa"
  }, [_c('span', [_c('img', {
    staticClass: "frame10",
    attrs: {
      "alt": "RealLifeOrg_FINAL-25.png",
      "src": "OEBPS/image/RealLifeOrg_FINAL-25_fmt.png"
    }
  })]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "b-head"
  }, [_vm._v("BUTTERFLY"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', [_vm._v("A Butterfly is a very visual person and generally likes to see all their belongings for fear of ")]), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("“out of sight, out of mind.”")]), _c('span', [_vm._v(" While almost all ClutterBugs need to have some important papers or reminders in plain sight in order to remember them, Butterflies take this to an extreme and struggle to put things “away” when they are done using them. Unfortunately, it just isn’t feasible to leave all of our things out all of the time. ")]), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("You are probably a Butterfly if you have clothing on top of your dresser and on the floor, but your closet and drawers are practically empty. ")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Butterflies are often overwhelmed with the idea of organizing, have no idea where to begin, and therefore put off starting big organizing projects. They also can become easily distracted and can float like a “butterfly” from task to task without really completing any of the projects that they begin. A Butterfly has to be careful not to overrun their home with clutter which can steal their time, energy and can have a negative impact of those they love."), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("With all of that being said, Butterflies are almost always fun, artistic, creative individuals who, once their space is organized in a way that works for their style, can take immense pride in making their home a beautiful and inspiring retreat for themselves and their family."), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("There are many ways a Butterfly can be organized with everything in its place, without the fear of forgetting where something is. Here are some quick tips just for Butterflies:"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "calibre6"
  }, [_c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("Brightly colored or clear bins are perfect for you and can motivate you to put your things away! Keep the lids off, though, so you are more likely to use them. By keeping your organizing solutions clear or colorful, you will be much more likely to use them and it will be a visual reminder of where your items are! Consider red bins for crafts, blue for office supplies, or all clear bins so you can always see what is inside."), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _c('span', [_vm._v("Label, label, label. Labeling is magic and every bug should do this, but it is most important for Butterflies and Crickets. You can use word or pictures to label your bins and baskets so you always have a visual reminder of what is inside. Use clearly labeled baskets for mail, clothing, office supplies, paperwork and just about everything else. There have been numerous studies that show people are ")]), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("three times")]), _c('span', [_vm._v(" more likely to put something away if the home is clearly labeled.")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("Bulletin boards work really well to help you organize your schedules, to-do lists, and even your thoughts in a clearly visible manner! You really need to take advantage of your vertical wall space more than any other bug! Chalkboard walls, white boards, corkboards and other display boards are key to keeping your home running smoothly."), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("Butterflies are easily distracted by their own clutter. Have a friend or family member help you with your bigger organizing projects in order to keep you on track. Invite someone over and ask him or her to help you sort your items and choose things to be donated or tossed out. Once the piles are sorted and paired down, you and your helper can place your items into colorful or clear baskets and put them away. "), _c('span', {
    staticClass: "normal-caps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "image-aa"
  }, [_c('span', [_c('img', {
    staticClass: "frame11",
    attrs: {
      "alt": "RealLifeOrg_FINAL-26.jpg",
      "src": "OEBPS/image/RealLifeOrg_FINAL-26_fmt.jpeg"
    }
  })]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-aa"
  }, [_c('span', [_c('img', {
    staticClass: "frame12",
    attrs: {
      "alt": "RealLifeOrg_FINAL-27.png",
      "src": "OEBPS/image/RealLifeOrg_FINAL-27_fmt.png"
    }
  })]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "calibre6"
  }, [_c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("Use the four-sort method when organizing any space. Have four labeled or color coded baskets, bags, or boxes handy: one for "), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("Trash")]), _vm._v(", one for "), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("Donate")]), _vm._v(", one for "), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("Does Not Belong in This Area")]), _vm._v(", and one for "), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("Keep")]), _vm._v(". This will help you stay focused and make purging, sorting, and donating your items easier. Butterflies can become distracted if they are moving from room to room to put items away. Wait until one room or space is done before putting away the DOES NOT BELONG items. "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("Have a clear vision for your space. Take a before picture of the mess right now and then find a picture in a magazine or online of what you want your space to look like when you are done. Hang both of these in your room somewhere for a visual reminder and motivation. "), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("Butterflies are visually motivated and this trick can really help you stay on track.")]), _vm._v(" "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("A 21 "), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("Item Toss")]), _vm._v(" every month is a great way for Butterflies to purge. Butterflies and Bees really need to make purging a priority in order to have a space they can easily maintain. Remind yourself that "), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("less is more")]), _vm._v(" and that by removing the items you don’t love, use, or find beautiful, you will be able to see the things you do love much more easily. Find out more about this painless purging trick in the next chapter."), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("Schedule organizing time each and every day. Schedule in fifteen minutes each day and work on one small part of your space. Try to pick the same time every day, like right after the kids go to bed each night. The average one hour television show has fifteen minutes of commercials, so you can easily squeeze in some quick organizing time while you watch your favorite show!"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("Hooks are a Butterfly’s best friend! Hang hooks in your entrance way, inside your closet, and on the back of all of your doors! A hook is the best way to ensure you will hang up your coat, bag, and everything else you tend to struggle putting away!"), _c('span', {
    staticClass: "normal-caps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "normal-caps"
  }), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "calibre6"
  }, [_c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("Open-shelving works best for you! Take advantage of vertical space and get stuff off your floor. Invest in shelving and closet organizers in order to maximize your storage. While I always say that organization should never be expensive, investing in shelving is always worth it! Your shelving doesn’t have to be expensive, though, and you can find amazing storage solutions at thrift stores, garage sales, and online swap sales. My favorite place to buy shelving units is always Ikea. "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("Remember, stuff is just stuff. Don’t put your belongings above your family or yourself. Clutter can have a very negative impact on children and relationships, and just by getting rid of the things you do not use or love, you can drastically improve the quality of life for your entire family. "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("Practice the “One Minute Rule.” Butterflies tend to procrastinate cleaning and putting things away when they are done with them. Remind yourself often that if something takes “One Minute or Less” to accomplish, do it right now! “Later” should be a word that you work hard to erase for your vocabulary. "), _c('span', {
    staticClass: "normal-caps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "image-aa"
  }, [_c('span', [_c('img', {
    staticClass: "frame13",
    attrs: {
      "alt": "RealLifeOrg_FINAL-29.png",
      "src": "OEBPS/image/RealLifeOrg_FINAL-29_fmt.png"
    }
  })]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "b-head"
  }, [_vm._v("CRICKET"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("A Cricket is a classic piler! They are very neat and tidy piles, but piles nonetheless. Crickets tend to be very logical and practical, and like things organized in a very certain way. Once a filing or organizing system is set in place, a Cricket will have no problem following it…it’s just a matter of finding the time to setup that right system! "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Crickets are often quite organized and maybe even a bit over organized. Crickets like very detailed and logical organizing systems, which can sometimes take too much time to setup or require too much effort to use properly. Therefore, Crickets will stack neat piles until they have time to put them away properly or until they have “dealt with” and finished using the item completely."), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Most Crickets are perfectionists. They feel that if they can’t do something perfectly, why bother doing it at all. This can lead to a build-up of multiple to-do piles that can easily get out of control."), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The best solution for a Cricket is to let go a little bit. Crickets need to remind themselves that creating “good enough” organizing systems for their items today is better than creating perfect homes for their items tomorrow. You can always go back and fine-tune an organizing system when you have the time to spare, but in the meantime, at least it is neat and organized and not taking up valuable surface space in your home. "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Try “macro-organizing” your piles instead of “micro-organizing” them. Here is an example: Joe wants to file his financial paperwork into a filing system. He wants a filing system for all of his investments, with separate, labeled folders for each year and each different account. He also wants separate folders for each bank account and one for each of his children’s college funds. In the meantime, all his papers are stacked in neat piles on his desk and have been for months. A good solution would be to make one file called “Investments” and file everything together for the meantime. He can always “micro-organize” this file folder at a later time, but at least it is put away today! Here are some good organizing solutions for Crickets:"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "calibre6"
  }, [_c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("Set up a vertical filing system, like a magazine rack, close to your desk or a wherever you tend to pile your important papers. This will be your “Action File.” Place important papers you need to deal with here, in sorted and labeled slots. Remember, horizontal is hidden and vertical is visible. Papers that are piled can easily become forgotten about and invisible to you, while papers stored vertically are easily seen and will be a visual reminder. "), _c('span', {
    staticClass: "normal-caps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "image-aa"
  }, [_c('span', [_c('img', {
    staticClass: "frame14",
    attrs: {
      "alt": "RealLifeOrg_FINAL-30.png",
      "src": "OEBPS/image/RealLifeOrg_FINAL-30_fmt.png"
    }
  })]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "calibre6"
  }, [_c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("Set a timer when organizing to encourage you to move fast and stay focused. Crickets are very task-oriented, and a timer can be a very efficient motivating tool. "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("Invest in a scanner, or at the very least a filing cabinet. Crickets can really benefit from going paperless, since paper is usually the biggest organizing issue they struggle with. Some Crickets find it easier to file all of their papers electronically. "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("Invest in a label maker. If you do have to file papers, using a label maker can not only make setting up filing systems faster, but it can also help make the systems even more efficient and easy to use. "), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("Place open baskets or bins on your desk, kitchen counter, or other surface to hold your piles until you can get to them. A full basket will be a visual reminder that your stack is getting too big for the basket and it is time to put it away."), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("Make yourself a to-do list on a traditional pad of paper, on your phone, or in your calendar. Crickets, more than any other bug, can really benefit from daily, weekly, and monthly to-do lists, as they are motivated to check items off their physical list. The motivation to complete lists can make crickets very high-achievers."), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("Turn off distractions, like your phone, email, and television when starting an organizing project. Crickets work best while listening to music or audiobooks while they work. Remind yourself that creating efficient organizing systems will save you time and effort in the long run and should be a priority to you."), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("Paper is kryptonite to your organizational super powers. Invest in a paper shredder and use it—often!"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("Remind yourself that "), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("perfectionism leads to procrastination")]), _vm._v(". Sometimes good enough for now is really…good enough. This will be hard for Crickets at first, but with practice, you will start to see that you can accomplish so much more when you let go of the need to make everything perfect all the time. Organizing something “good enough” today is always better than putting it off until the “perfect time.” You can always go back and tweak and improve on your systems at a later date. "), _c('span', {
    staticClass: "normal-caps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "image-aa"
  }, [_c('span', [_c('img', {
    staticClass: "frame15",
    attrs: {
      "alt": "RealLifeOrg_FINAL-33.png",
      "src": "OEBPS/image/RealLifeOrg_FINAL-33_fmt.png"
    }
  })]), _c('span', [_c('img', {
    staticClass: "frame10",
    attrs: {
      "alt": "RealLifeOrg_FINAL-32.png",
      "src": "OEBPS/image/RealLifeOrg_FINAL-32_fmt.png"
    }
  })]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "b-head"
  }, [_vm._v("LADYBUG"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Ladybugs are enigmas! Have you ever seen a real ladybug (like, the actual bug) with their wings open? Yuck. With their wings closed, they are adorable with beautifully bright red and shiny polka dotted shells, but once those wings open up, it is a freaking horror show under there! That is basically exactly the same as a “Ladybug’s” home. The main living areas tend to be tidy and even beautifully decorated, but under the surface, they are shoving and hiding like the “hidey-hoarders” they really are!"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Ladybugs are generally stressed out by surface clutter and strive to keep their living space clean and clutter-free. You know you’re a Ladybug if your surfaces are clean and tidy, but your junk drawer is overflowing and you may be impaled by falling junk when you open your closet. Without a mirco-organizing system in place, the small stuff can get shoved here, there, and everywhere! Ladybugs need to work on setting up systems inside drawers and closets that are quick and easy to use. Here are some tips just for the Ladybug:"), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "calibre6"
  }, [_c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _vm._v("Set aside fifteen minutes per week (or even more often) and pick one “hidden” area in your home to reorganize. Ladybugs can easily follow most organizing systems; they just need to schedule time to make it a priority."), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _c('span', [_vm._v("Use drawer dividers or small open containers to keep like items together inside ")]), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("each and every one of your drawers.")]), _c('span', [_vm._v(" Examples: batteries, pens, tools, jewellery, makeup, tape, craft supplies, etc. Using dividers or open containers means you can just open the drawer and easily toss the item in its home! Drawer dividers are a MUST for Ladybugs in order to keep those spaces tidy and organized. ")]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('li', {
    staticClass: "body-bl-serif"
  }, [_c('span', {
    staticClass: "character-style"
  }, [_vm._v("•\t")]), _c('strong', {
    staticClass: "char-style-override4"
  }, [_vm._v("If it is hard to put away, you won’t do it.")]), _vm._v(" Make sure your storage solutions are easily accessible and clearly labeled. Use containers without lids inside drawers, closets, and just about everywhere else! Open-lidded containers allow you to still toss and hide your items in your hidden areas, but in an organized and easy-to-find later way. If you have to stop and take the lid off your storage container, you are likely to just set the item on top. "), _c('span', {
    staticClass: "normal-caps"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "image-aa"
  }, [_c('span', [_c('img', {
    staticClass: "frame16",
    attrs: {
      "alt": "Photo9.jpg",
      "src": "OEBPS/image/Photo9_fmt.jpeg"
    }
  })]), _c('span', {
    staticClass: "normal-caps"
  })]), _vm._v(" "), _c('div', {
    staticClass: "calibre2",
    attrs: {
      "id": "calibre_pb_14"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33889298","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/RealLifeOrg_split_014.vue
// module id = 99
// module chunks = 0